<template>
  <div>
    <a-modal
      :visible="true"
      @cancel="onCancel"
      :maskClosable="false"
      :width="900"
      style="min-height:600px"
      @ok="onSubmitEvent"
      title="高级设置">
      <a-form-model
        ref="form" :model="form" :rules="editRules" :label-col="labelCol" :wrapper-col="wrapperCol"
        class="withdraw-form">
        <a-form-model-item label="审核规则" prop="ruleType">
          <a-radio-group
            style="width: 100%"
            v-model:value="form['ruleType']"
          >
            <a-radio :value="1">指定商品</a-radio>
            <a-radio :value="2">按类目</a-radio>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item v-if="form.ruleType===2" label="商品类目" :colon="false" prop="targetValue">
          <a-checkbox-group v-model="form.targetValue" style="width: 100%;" placeholder="请选择">
            <a-checkbox v-for="(item, index) in proCatalogEnum" :key="index" :value="String(item.value)">
              {{ item.key }}
            </a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>

        <a-form-model-item v-else label="关联商品" :colon="false" prop="targetValue ">
          <a-select style="width: 20%;" placeholder="请选择" v-model:value="form.targetType">
            <a-select-option :value="1">关联单个商品</a-select-option>
            <a-select-option :value="2">关联商品分组</a-select-option>
          </a-select>
          <div class="select-box">
            <a-select
              v-model:value="form.targetValue"
              :open="false"
              style="width: 100%"
              :options="selectOptions"
              placeholder="选择"></a-select>
            <div class="mask-box" @click="toSelectEvent"></div>
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!--关联商品-->
    <selected-product-dialog
      :show="showSelectedDialog"
      :width="1200"
      ref="pageList"
      :itemNames="['search_proId','search_proName']"
      :query-params="selectedQueryParams"
      :requestPromise="getModularProductPromise"
      row-key="proId"
      @close="showSelectedDialog=false"
      :columns="getGoodsColumns()"
    >
      <a-form-item label="商品ID" slot="search_proId" v-bind="currentDialogLayout">
        <a-input v-model="selectedQueryParams.proId" style="width: 170px" placeholder="请输入商品ID"></a-input>
      </a-form-item>
      <a-form-item label="商品名称" slot="search_proName" v-bind="currentDialogLayout">
        <a-input v-model="selectedQueryParams.proName" style="width: 170px" placeholder="请输入商品名称"></a-input>
      </a-form-item>
      <template slot="proCatalog" slot-scope="rowItem">
        {{ getProCatalogName(rowItem.record.proCatalog, proCatalogEnum) }}
      </template>
      <template slot="action" slot-scope="rowItem">
        <a-button type="primary" @click="onSelectedResult(rowItem.record)">选择</a-button>
      </template>
    </selected-product-dialog>
    <!--选择分组-->
    <selected-product-dialog
      ref="groupDialog"
      :width="1200"
      :col="2"
      :show="showSelectedGroupDialog"
      :itemNames="['search_proName']"
      :query-params="selectedQueryGroupParams"
      :request-promise="getGroupRequest"
      @close="showSelectedGroupDialog=false"
      :columns="getGroupColumns()"
    >
      <a-form-item
        label="商品分组名称"
        slot="search_proName"
        :wrapperCol="{span:18}"
        :labelCol="{span:6}">
        <a-input
          v-model="selectedQueryGroupParams.groupName"
          style="width: 100%"
          placeholder="请输入商品分组名称"
        ></a-input>
      </a-form-item>
      <template slot="action" slot-scope="rowItem">
        <a-button type="primary" @click="onSelectedGroupResult(rowItem.record)">选择</a-button>
      </template>
    </selected-product-dialog>
  </div>

</template>
<script>
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog.vue'
import productMixins from '@/utils/mixins/productMixins'

export default {
  name: 'AdvancedProcessSettingsDialog',
  components: { SelectedProductDialog },
  props: {
    enterpriseId: {
      type: String,
      default: '',
      required: true
    },
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    editConfigList: {
      type: Array,
      default: () => {
        return []
      }
    },
    rules: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  mixins: [productMixins],
  data() {
    return {
      proCatalogEnum: [],
      selectedFormLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      currentDialogLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      selectedRowKeys: [],
      showSelectedDialog: false,
      showSelectedGroupDialog: false,
      selectedQueryParams: {
        proName: '',
        proId: '',
        shelfStatus: '1'
      },
      selectedQueryGroupParams: { groupStatus: 1 },
      form: {
        ruleType: 2,
        targetType: undefined,
        targetValue: undefined
      },
      editRules: {
        ruleType: [
          { required: true, message: '请选择规则', trigger: 'change,blur' }
        ],
        targetValue: [
          { required: true, validator: this.handleTarget }
        ]
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      selectOptions: [],
      initFinish: false
    }
  },
  mounted() {
    this.getDetails()
  },
  watch: {
    'form.ruleType': function(newVal, oldVal) {
      if (this.initFinish) {
        this.form.targetValue = undefined
        this.form.targetName = undefined
        if (this.form.ruleType === 2) {
          this.form.targetType = undefined
        } else {
          this.form.targetType = 1
          this.selectOptions = []
        }
      }
    },
    'form.targetType': function(newVal, oldVal) {
      if (this.initFinish) {
        this.selectOptions = []
        this.form.targetValue = undefined
        this.form.targetName = undefined
      }
    }
  },
  methods: {
    getDetails() {
      const url = 'member/v3/auth/authAuditRuleDetail'
      this.getHttpServices().getMemberAuthService()
        .post(url, { enterpriseId: this.enterpriseId })
        .then(res => {
          if (String(res.ruleType) === '2') {
            res.targetValue = res.targetValue.split(',')
          }
          this.form = { ...res }
          this.$nextTick(() => {
            this.initFinish = true
            if (String(res.ruleType) !== '2') {
              this.selectOptions = [
                {
                  label: res.targetName,
                  value: res.targetValue
                }
              ]
            }
          })
        })
        .catch(err => {
          this.initFinish = true
          console.error(err)
        })
    },
    onCancel() {
      this.$emit('cancel')
    },
    handleTarget(rule, value, callback) {
      if (!value) {
        const msg = this.form.ruleType === 1 ? '请选择绑定商品' : '请选择商品类目'
        callback(new Error(msg))
      } else {
        callback()
      }
    },
    toSelectEvent() {
      if (this.form.targetType === 1) {
        this.showSelectedDialog = true
      } else {
        this.showSelectedGroupDialog = true
      }
    },
    onSelectedResult(obj) {
      console.error('--onSelectedResult--', obj)
      this.selectOptions = [
        {
          label: obj.proName,
          value: obj.proId
        }
      ]
      this.form.targetValue = obj.proId
      this.form.targetName = obj.proName
      this.showSelectedDialog = false
    },
    onSelectedGroupResult(item) {
      this.selectOptions = [
        {
          label: item.groupName,
          value: item.groupId
        }
      ]
      this.form.targetValue = item.groupId
      this.form.targetName = item.groupName
      this.showSelectedGroupDialog = false
    },
    requestSave() {
      const url = 'member/v3/auth/saveAuthAuditRule'
      const params = {
        ...this.form,
        enterpriseId: this.enterpriseId
      }
      if (Array.isArray(params.targetValue)) {
        params.targetValue = params.targetValue.join(',')
      }
      this.getHttpServices().getMemberAuthService()
        .post(url, params)
        .then(res => {
          this.onCancel()
          this.$emit('ok')
          this.$message.success('设置成功')
        }).catch(err => {
        console.error(err)
        if (err.msg) {
          this.$message.error(err.msg)
        } else {
          this.$message.error('设置失败，请重试！')
        }
      })
    },
    onSubmitEvent() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.requestSave()
        } else {
          this.$message.error('请完善表单信息！')
        }
      })
    }
  }
}
</script>


<style scoped lang="less">
.select-box {
  height: 100%;
  margin-left: 20px;
  width: calc(80% - 20px);
  position: relative;
  display: inline-block;

  .mask-box {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: transparent;
  }
}
</style>